(function(){
$(document).ready(function(){

  $('[data-section-id] [data-product-form]').on('submit', function(e){
    e.preventDefault();

    var params = {
      url: '/cart/add.js',
      data: $(this).serialize(),
      dataType: 'json'
    };

    
    
    $.post(params)
    .done(
      function(item) {
        // console.log(item);
        
          $('[data-cart-popup-wrapper]').removeAttr('hidden');
          $('[data-cart-popup-wrapper]').removeClass('cart-popup-wrapper--hidden').addClass('is-transitioning');
          $('[data-cart-popup-title]').text(item.product_title);
          $('[data-cart-popup-quantity]').text($(".quantity-incrementor input").val());
          if(item.options_with_values[0].name != 'Title'){
            $('[data-cart-popup-product-details]').html("<li>" + item.options_with_values[0].name + ':' + item.options_with_values[0].value  + "</li>"); 
          }
          $('[data-cart-popup-image-placeholder]').html('<img src=' + item.image + '"' + 'alt=" ' + item.product_title + '" class="cart-popup-item__image" data-cart-popup-image="">' );
          
          let current_qty = parseFloat($(".quantity-incrementor input").val()); 
          let old_qty = parseFloat($("header .logo-wrapper .user-wrapper a.cart-icon span").text());
          
          if(old_qty === 0 && parseFloat($('[data-cart-popup-cart-quantity]').text()) > 0){
            old_qty = parseFloat($('[data-cart-popup-cart-quantity]').text()); 
          }
          else if (parseFloat($('[data-cart-popup-cart-quantity]').text()) > 0){
            old_qty = parseFloat($('[data-cart-popup-cart-quantity]').text()); 
          }
          $('[data-cart-popup-cart-quantity]').text(current_qty + old_qty);
          

        }.bind(this)
      )
      .fail(
        function(response) {
          console.log(response);
        }.bind(this)
      );
  });

  $(document).on('click', '[data-cart-popup-dismiss], [data-cart-popup-close]', function(){
    $('[data-cart-popup-wrapper]').attr('hidden','true');
    $('[data-cart-popup-wrapper]').addClass('is-transitioning').removeClass('cart-popup-wrapper--hidden');
  });


  $(document).on('click', function(e) {
    var container = $('[data-cart-popup-wrapper]');
    if (!$(e.target).closest(container).length) {
      $('[data-cart-popup-wrapper]').attr('hidden','true');
      $('[data-cart-popup-wrapper]').addClass('is-transitioning').removeClass('cart-popup-wrapper--hidden');
    }
  });
});
})(jQuery)